import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coderush',
  templateUrl: './coderush.component.html',
  styleUrls: ['./coderush.component.scss']
})
export class CoderushComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
